import { render, staticRenderFns } from "./ChannelFilter.vue?vue&type=template&id=1fde5feb&scoped=true"
import script from "./ChannelFilter.vue?vue&type=script&lang=js"
export * from "./ChannelFilter.vue?vue&type=script&lang=js"
import style0 from "./ChannelFilter.vue?vue&type=style&index=0&id=1fde5feb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde5feb",
  null
  
)

export default component.exports